export enum Energieart {
    UNKNOWN = 'UNKNOWN',
    WIND = 'WIND',
    GASE_BIOMASSE = 'GASE_BIOMASSE',
    WASSER = 'WASSER',
    SOLAR = 'SOLAR',
    BHKW = 'BHKW',
    GEOTHERMIE = 'GEOTHERMIE'
}

export class EnergieartItem {

    public key: string;
    public description: string;

    constructor(key: string, description: string) {
        this.key = key;
        this.description = description;
    }

    public static getAll(): EnergieartItem[] {
        return [
            new EnergieartItem(Energieart.UNKNOWN, 'UNKNOWN'),
            new EnergieartItem(Energieart.WIND, 'WIND'),
            new EnergieartItem(Energieart.GASE_BIOMASSE , 'GASE_BIOMASSE'),
            new EnergieartItem(Energieart.WASSER , 'WASSER'),
            new EnergieartItem(Energieart.SOLAR , 'SOLAR'),
            new EnergieartItem(Energieart.BHKW , 'BHKW'),
            new EnergieartItem(Energieart.GEOTHERMIE , 'GEOTHERMIE'),
        ];
    }

}

